import { useTranslation, Trans } from "react-i18next";

import w1 from '../../img/Bonus/w1.svg';
import w2 from '../../img/Bonus/w2.svg';
import w3 from '../../img/Bonus/w3.svg';

import Button from "../Button";

function Main() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[40px] xl:pt-[60px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col xl:flex-row items-center gap-[20px] justify-between">
                <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[600px]">
                    <Trans>{t("bonus.1")}</Trans>
                </p>
                <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex">
                    {t("bonus.2")}
                </p>
            </div>
            <div className="mt-[40px] xl:mt-[50px] flex flex-col xl:flex-row gap-[6px] xl:gap-0 xl:h-[440px] w-full">
                <div className="bg-[#2A2A3D] border border-[#47475E] w-full pb-[20px] xl:pb-0">
                    <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] bg-[#2045FE] mx-[20px] xl:mx-[40px] mt-[20px] flex items-center justify-center">
                        <img src={w1} alt="" className="w-[28px] xl:w-[36px]"/>
                    </div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF] mx-[20px] xl:mx-[40px] mt-[20px] xl:mt-[30px]">{t('bonus.3')}</p>
                    <p className="mx-[20px] xl:mx-[40px] mt-[12px] text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex"><Trans>{t('bonus.4')}</Trans></p>
                </div>
                <div className="bg-[#2A2A3D] border xl:border-0 xl:border-t xl:border-b border-[#47475E] w-full pb-[20px] xl:pb-0">
                    <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] bg-[#2045FE] mx-[20px] xl:mx-[40px] mt-[20px] flex items-center justify-center">
                        <img src={w2} alt="" className="w-[28px] xl:w-[36px]"/>
                    </div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF] mx-[20px] xl:mx-[40px] mt-[20px] xl:mt-[30px]"><Trans>{t('bonus.5')}</Trans></p>
                    <p className="mx-[20px] xl:mx-[40px] mt-[12px] text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex"><Trans>{t('bonus.6')}</Trans></p>
                </div>
                <div className="bg-[#2A2A3D] border border-[#47475E] w-full pb-[20px] xl:pb-0">
                    <div className="w-[54px] h-[54px] xl:w-[69px] xl:h-[69px] bg-[#2045FE] mx-[20px] xl:mx-[40px] mt-[20px] flex items-center justify-center">
                        <img src={w3} alt="" className="w-[28px] xl:w-[36px]"/>
                    </div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF] mx-[20px] xl:mx-[40px] mt-[20px] xl:mt-[30px]">{t('bonus.7')}</p>
                    <p className="mx-[20px] xl:mx-[40px] mt-[12px] text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex"><Trans>{t('bonus.8')}</Trans></p>
                </div>
            </div>
            <Button className={'mx-auto mt-[20px] xl:w-[400px]'}/>
        </div>
    </div>
  );
}

export default Main;
